<template>
  <svg
    v-if="definition && definition.icon"
    xmlns="http://www.w3.org/2000/svg"
    :class="$props.class"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <path fill="currentColor" :d="svgPath" />
  </svg>
  <span v-else class="missing-icon" :class="$props.class">
    {{ icon }}
  </span>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';

export default defineComponent({
  name: 'FontAwesomeIcon',

  props: {
    icon: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'fal',
      required: false,
    },
    class: String,
  },

  setup(props) {
    const definition = computed(() => {
      try {
        return findIconDefinition({
          prefix: props.type,
          iconName: props.icon,
        });
      } catch (error) {
        console.warn(`FontAwesome icon not found: ${props.type}-${props.icon}`);
        return null;
      }
    });

    const width = computed(() => definition.value?.icon?.[0] || 16);
    const height = computed(() => definition.value?.icon?.[1] || 16);
    const svgPath = computed(() => definition.value?.icon?.[4] || '');

    return { definition, width, height, svgPath };
  },
});
</script>

<style scoped>
.missing-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  background-color: #ccc;
  border-radius: 2px;
  font-size: 0.8em;
  text-align: center;
  line-height: 1em;
  color: #666;
}
</style>
